/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_CopiedInputs */



/**
* | output |
* | --- |
* | "Error details copied to clipboard" |
*
* @param {Chat_Error_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_copied = /** @type {((inputs?: Chat_Error_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlerdetails in die Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Error details copied to clipboard")
});